import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

//helpers:
import { getData, postData, putData } from '../dataLib';

//actions:
import { openDialog, hideDialog, setSaveState } from '../actions/index';
import { modifyDatosCierreDiario } from '../actions/cierre_diario_actions';

//components
import FloatNumberFormatInput from '../components/float_number_input_formatter';
import IntNumberFormatInput from '../components/int_number_input_formatter';


const styles = theme => ({
    formContainer: {
        padding: 5,
        display: 'flex',
        flexDirection: 'column',
    },
    hoursContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexFlow: 'wrap',
        alignContent: 'space-around',
        marginBottom: 10,
    },
    contentContainer: {
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: 'space-between',
    },
    formItem: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        maxWidth: 110,
        marginTop: theme.spacing(2),
    },
    label: {
        textAlign: 'left',
        width: 50,
        fontSize: 13,
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 65,
        height: 30,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
        textAlign: 'right'
    },
    inputTotal: {
        width: 85,
        height: 30,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    observTextField: {
        display: 'flex',
        height: '100%',
        margin: theme.spacing(1),
    },
    inputObserv: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',
        fontSize: 12,
        height: '90%',
    },
});

class Arqueo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            arqueo: {
                id: -1,
                cajaId: -1,
                Fecha: '',
                usuarioId: 0,
                billete500: 0,
                billete200: 0,
                billete100: 0,
                billete50: 0,
                billete20: 0,
                billete10: 0,
                billete5: 0,
                moneda2: 0,
                moneda1: 0,
                moneda050: 0,
                moneda020: 0,
                moneda010: 0,
                moneda005: 0,
                moneda002: 0,
                moneda001: 0,
                isManual: 0,
                observDescuadre: ''
            },
            total: 0.0,
            showSpinner: true,
        }
    }

    componentDidMount() {
        this.getArqueo();
    }

    calculateTotal = (arqueo) => {
        let total = 0.0;

        total += 500.0 * parseFloat(arqueo.billete500);
        total += 200.0 * parseFloat(arqueo.billete200);
        total += 100.0 * parseFloat(arqueo.billete100);
        total += 50.0 * parseFloat(arqueo.billete50);
        total += 20.0 * parseFloat(arqueo.billete20);
        total += 10.0 * parseFloat(arqueo.billete10);
        total += 5.0 * parseFloat(arqueo.billete5);
        total += 2.0 * parseFloat(arqueo.moneda2);
        total += 1.0 * parseFloat(arqueo.moneda1);
        total += 0.50 * parseFloat(arqueo.moneda050);
        total += 0.20 * parseFloat(arqueo.moneda020);
        total += 0.10 * parseFloat(arqueo.moneda010);
        total += 0.05 * parseFloat(arqueo.moneda005);
        total += 0.02 * parseFloat(arqueo.moneda002);
        total += 0.01 * parseFloat(arqueo.moneda001);

        return total;
    }

    getArqueo = () => {

        let arqueoURL = '';

        if (this.props.producto !== undefined) { //cierre diario
            if (this.props.producto.articuloId === 0) arqueoURL += 'dearqueos/arqueoIngresosBanco?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.centroDiaSelected.dia;
            else arqueoURL += 'dearqueos/cierrediario?articulo_id=' + this.props.producto.articuloId + '&date=' + this.props.centroDiaSelected.dia;
        }
        else if (this.props.cajaId) { //por caja 
            arqueoURL += 'dearqueos/arqueoPorCaja?caja_id=' + this.props.cajaId + '&date=' + this.props.centroDiaSelected.dia;
        }
        else if (this.props.centroId) { //ingresos banco
            arqueoURL += 'dearqueos/arqueoIngresosBanco?centro_id=' + this.props.centroId + '&date=' + this.props.fecha;
        }
        else return;

        getData(
            arqueoURL,
            (response) => {
                this.setState({ ...this.state, arqueo: response.data, total: this.calculateTotal(response.data), showSpinner: false })
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching arqueo'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    }

    updateArqueo = () => {

        this.setState({...this.state, showSpinner: true});

        putData(
            'dearqueos/' + this.state.arqueo.id,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'arqueo actualizado'
                }, 'arqueo_actualizado_dialog', false, 'sm');
                if (this.props.producto !== undefined) { //cierre diario
                    this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: this.state.total })
                }
                else if (this.props.okHandler !== undefined) this.props.okHandler(this.state.total);
                this.props.setSaveState(false);
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating arqueo'
                }, 'error_arqueo_actualizado_dialog', false, 'sm');
                this.setState({...this.state, showSpinner: false});
            },
            { ...this.state.arqueo, usuarioId: this.props.user ? this.props.user.profile.sub : 0 },
            this.props.user

        );


    }

    newArqueo = () => {

        this.setState({...this.state, showSpinner: true});

        postData(
            'dearqueos',
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'arqueo actualizado'
                }, 'arqueo_actualizado_dialog', false, 'sm');
                this.props.setSaveState(false);
                if (this.props.producto !== undefined) { //cierre diario
                    this.props.modifyDatosCierreDiario({ ...this.props.producto, importe: this.state.total })
                }
                else if (this.props.okHandler !== undefined) this.props.okHandler(this.state.total);
                this.props.setSaveState(false);
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating arqueo'
                }, 'error_arqueo_actualizado_dialog', false, 'sm');
                this.setState({...this.state, showSpinner: false});
            },
            { ...this.state.arqueo, usuarioId: this.props.user ? this.props.user.profile.sub : 0 },
            this.props.user

        );

    }

    handleValueChange = (event, field) => {
        //const value = (event.target.value === '') ? 0 : event.target.value
        let newArqueo = { ...this.state.arqueo, [field]: event.target.value };
        this.props.setSaveState(true);
        this.setState({ ...this.state, arqueo: newArqueo, total: this.calculateTotal(newArqueo) });
    }

    handleBlur = (event, field) => {
        if (event.target.value === '') {
            let newArqueo = { ...this.state.arqueo, [field]: 0 };
            this.setState({ ...this.state, arqueo: newArqueo, total: this.calculateTotal(newArqueo) });
        }
    }


    renderTextField = (label, field) => {

        const { classes } = this.props;

        return (

            <div className={classes.formItem}>
                <Typography variant="subtitle2" className={classes.label}>
                    {label}
                </Typography>

                <TextField
                    id={field}
                    placeholder='0'
                    value={this.state.arqueo[field]}
                    onChange={(event) => this.handleValueChange(event, field)}
                    onBlur={(event)=> this.handleBlur(event,  field )}
                    className={classes.input}
                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                    variant="outlined"
                    disabled={this.props.disabled}
                />
            </div>
        )
    }


    render() {

        const { classes } = this.props;

        if (this.state.showSpinner)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
            );

        return (
            <form className={classes.formContainer}>

                <div className={classes.contentContainer}>

                    <div className={classes.hoursContainer}>
                       
                        {this.renderTextField('500 €', 'billete500')}
                        {this.renderTextField('200 €', 'billete200')}
                        {this.renderTextField('100 €', 'billete100')}
                        {this.renderTextField('50 €', 'billete50')}
                        {this.renderTextField('20 €', 'billete20')}
                        {this.renderTextField('10 €', 'billete10')}
                        {this.renderTextField('5 €', 'billete5')}

                    </div>
                    <div className={classes.hoursContainer}>
                       
                        {this.renderTextField('2 €', 'moneda2')}
                        {this.renderTextField('1 €', 'moneda1')}
                        {this.renderTextField('0,50 €', 'moneda050')}
                        {this.renderTextField('0,20 €', 'moneda020')}
                        {this.renderTextField('0,10 €', 'moneda010')}
                        {this.renderTextField('0,05 €', 'moneda005')}
                        {this.renderTextField('0,02 €', 'moneda002')}
                        {this.renderTextField('0,01 €', 'moneda001')}


                    </div>
                </div>

                <div className={classes.total}>
                    <p style={{ margin: 0 }}>Total</p>

                    <TextField
                        id="total"
                        value={this.state.total}
                        variant="outlined"
                        disabled
                        className={classes.input}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                    />
                </div>

                {
                    this.props.producto !== undefined ?
                        <TextField
                            className={classes.observTextField}
                            disabled={this.props.disabled}
                            placeholder={'Observaciones'}
                            InputProps={{
                                className: classes.inputObserv,
                            }}
                            id={'observDescuadre'}
                            value={this.state.arqueo.observDescuadre}
                            variant='outlined'
                            multiline
                            rowsMax='11'
                            rows='11'
                            onChange={(event) => this.handleValueChange(event, 'observDescuadre')}
                        /> : ''
                }


                <div>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                    {!this.props.disabled ? <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                        if (this.state.arqueo.id === -1) this.newArqueo();
                        else this.updateArqueo();
                    }}>Guardar</Button> : ''}
                </div>

            </form>
        );

    };

};

Arqueo.propTypes = {
    //state:
    user: PropTypes.object.isRequired,
    centroId: PropTypes.number,
    producto: PropTypes.object,
    cajaId: PropTypes.number,
    disabled: PropTypes.bool.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch:
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    okHandler: PropTypes.func,

};

function mapStateToProps(state) {

    return {
        centroDiaSelected: state.centroDiaSelected,
        user: state.oidc.user,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
        modifyDatosCierreDiario,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Arqueo));